import { render, staticRenderFns } from "./AddResident.vue?vue&type=template&id=c5611b30&scoped=true&"
import script from "./AddResident.vue?vue&type=script&lang=js&"
export * from "./AddResident.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5611b30",
  null
  
)

export default component.exports